import request from '@/utils/request';

export function getSignalStatusAsKeyValuePairList() {
  return request({
    url: '/api/status/GetStatusAsKeyValuePairList',
    method: 'get',
  });
}

